module.exports = __webpack_public_path__ + "static/media/Sekolah Kembang.235f890a.png";